import React, { useState } from 'react';

const BookCard = ({ book }) => {
  const [selectedFormat, setSelectedFormat] = useState(book.formats[0]);

  return (
    <article className="book-card">
      <div className="book-cover-wrapper">
        <img 
          src={book.coverUrl} 
          alt={`Cover of ${book.title}`}
          className="book-cover"
          loading="lazy"
        />
      </div>
      
      <div className="book-info">
        <h3 className="book-title">{book.title}</h3>
        {book.author ? (
          <p className="book-author">by {book.author}</p>
        ) : book.authorLabel ? (
          <p className="book-author">{book.authorLabel}</p>
        ) : null}
        <p className="book-description">{book.description}</p>
        
        {book.formats.length > 1 && (
          <div className="format-selector">
            {book.formats.map((format) => (
              <button
                key={format.type}
                className={`format-btn ${selectedFormat.type === format.type ? 'active' : ''}`}
                onClick={() => setSelectedFormat(format)}
              >
                {format.type}
              </button>
            ))}
          </div>
        )}
        
        <div className="book-price-row">
          <span className="book-price">${selectedFormat.price.toFixed(2)}</span>
          <span className="book-format-label">{selectedFormat.type}</span>
        </div>
        
        <a 
          href={book.checkoutUrl} 
          className="buy-btn"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className="buy-btn-text">PURCHASE</span>
          <span className="buy-btn-arrow">→</span>
        </a>
      </div>
    </article>
  );
};

export default BookCard;
